import { Controller } from '@hotwired/stimulus'

// Aperçu du HTML saisi par un admin (CGU, notification), au fil de la frappe ; `href` : l'aperçu
// devient un lien vers l'adresse saisie. La page publique, elle, passe par sanitize.
export default class extends Controller {
  static targets = ['source', 'preview', 'href', 'link']

  connect() {
    this.update()
  }

  update() {
    this.previewTarget.innerHTML = this.sourceTarget.value
    if (this.hasHrefTarget && this.hasLinkTarget) {
      // Comme la notification (Notifications::FromGods) : http(s) ou un chemin du site seulement.
      const href = this.hrefTarget.value.trim()
      if (/^https?:\/\//.test(href) || (href.startsWith('/') && !href.startsWith('//'))) this.linkTarget.setAttribute('href', href)
      else this.linkTarget.removeAttribute('href')
    }
  }
}
